import './AevocamOutlierMark.css'

export type AevocamOutlierMarkProps = {
  className?: string
}

const SINGLE_VB_W = 12
const SINGLE_VB_H = 10

/**
 * Bright green marker pointing down at the scrubber centerline.
 */
export function AevocamOutlierMark({
  className = '',
}: AevocamOutlierMarkProps) {
  const rootClass = ['AevocamOutlierMark', 'Single', className]
    .filter(Boolean)
    .join(' ')

  return (
    <svg
      className={rootClass}
      viewBox={`0 0 ${SINGLE_VB_W} ${SINGLE_VB_H}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <polygon
        className='Fill'
        points={`${SINGLE_VB_W / 2},${SINGLE_VB_H} 0,0 ${SINGLE_VB_W},0`}
      />
      <polyline
        className='Rim'
        points={`0,0 ${SINGLE_VB_W},0 ${SINGLE_VB_W / 2},${SINGLE_VB_H} 0,0`}
      />
    </svg>
  )
}
